import { all, takeLeading, takeEvery, put } from 'redux-saga/effects';
import { api, apiCall } from 'redux/helpers/api';
import { debouncePerType } from 'redux/helpers/saga';
import config from 'config';
import types from './types';
import actions from './actions';

const MIN_SEARCH_LENGTH = 2;

function* onFetchSuperpowers() {
  const { ok, response, error } = yield apiCall(api.superpowers.me);

  if (ok) {
    yield put(actions.fetchSuperpowersSuccess(response));
  } else {
    yield put(actions.fetchSuperpowersFailure(error));
  }
}

function* onFindMembers({ payload }) {
  if ((payload?.search || '').length < MIN_SEARCH_LENGTH) {
    return;
  }

  const { ok, response, error } = yield apiCall(api.superpowers.findMembers, payload);

  if (ok) {
    yield put(actions.findMembersSuccess(response));
  } else {
    yield put(actions.findMembersFailure(error));
  }
}

function* onGetMember({ payload }) {
  const { ok, response, error } = yield apiCall(api.superpowers.getMember, payload);

  if (ok) {
    yield put(actions.getMemberSuccess(response));
  } else {
    yield put(actions.getMemberFailure(error));
  }
}

function* onGetDownloads() {
  const { ok, response, error } = yield apiCall(api.superpowers.getDownloads);

  if (ok) {
    yield put(actions.getDownloadsSuccess(response));
  } else {
    yield put(actions.getDownloadsFailure(error));
  }
}

function* onDownloadFile({ payload }) {
  const { ok, error } = yield apiCall(api.superpowers.downloadFile, payload);

  if (ok) {
    yield put(actions.downloadFileSuccess(payload));
  } else {
    yield put(actions.downloadFileFailure({ ...payload, error }));
  }
}

export default function* superpowersSagas() {
  yield all([
    takeLeading(types.fetchSuperpowers, onFetchSuperpowers),
    debouncePerType(config.defaultTypingDebounce, types.findMembers, onFindMembers),
    takeEvery(types.getMember, onGetMember),
    takeLeading(types.getDownloads, onGetDownloads),
    takeEvery(types.downloadFile, onDownloadFile),
  ]);
}
